<!--
  --
  -- 摘要カード
  --
  -->
<template>
  <v-card>
    <v-card-title>摘要</v-card-title>

    <v-card-text>
      <!-- 乗車人数 -->
      <div class="d-flex mb-4">
        <div class="mr-auto">乗車人数</div>
        <div>
          <span class="text--primary font-weight-bold">{{peoples}}</span>
          <small class="ml-2">名</small>
        </div>
      </div>

      <!-- フライト -->
      <div v-if="flights.arrival" class="mb-4">
        <div class="d-flex">
          <div class="mr-auto">到着便</div>
          <div class="text--primary font-weight-bold">{{flights.arrival}}</div>
        </div>
        <div class="d-flex">
          <div class="mr-auto">出発便</div>
          <div class="text--primary font-weight-bold">{{flights.departure}}</div>
        </div>
      </div>

      <!-- 連絡事項 -->
      <div v-if="note">
        <div>連絡事項</div>
        <div class="text--primary font-weight-bold whitespace-pre-wrap">{{note}}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CRemarkCard',
  computed: {
    peoples () {
      return this.getters['book/peoples']
    },

    flights () {
      return this.getters['book/flights']
    },

    note () {
      return this.getters['book/note']
    }
  }
}
</script>
